module.exports = __webpack_public_path__ + "img/left3.a871e5d8.jpg";